<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="auto" @click:outside="switchCouponToggle">
      <v-card width="452" color="#212121" class="pa-5">
        <div class="d-flex justify-space-between align-center pb-4">
          <v-card-title class="pa-0" style="font-size: 18px">
            使用優惠券
          </v-card-title>
          <v-icon @click="switchCouponToggle" class="close-btn">
            mdi-window-close
          </v-icon>
        </div>
        <v-form ref="form" class="coupon-form">
          <v-radio-group v-model="activeDiscount" class="coupon-list">
            <div class="coupon-item d-flex align-center">
              <span class="text-14px">新增優惠券</span>
              <v-text-field
                filled
                outline
                dense
                v-model="discountInput"
                placeholder="請輸入優惠碼"
                class="text-body-2 discount-input"
                @keypress="onCodeInput"
                :height="36"
                :class="{ 'error-input': isEmptyDiscount }"
              ></v-text-field>
              <v-btn outlined class="exchange-btn" @click="redeemCoupon">
                兌換
              </v-btn>
            </div>
            <div class="mb-5">
              <span class="text-14px">優惠券</span>
            </div>
            <div
              class="no-coupon-hint"
              v-show="!discountItems.length"
            >
              <span>目前沒有可用優惠券</span>
            </div>
            <div v-show='discountItems.length' class="coupons-wrapper">
              <div
                v-for="item in discountItems"
                :key="item?.title"
                class="coupon-item d-flex align-center"
              >
                <v-radio class="coupon-item" label="" :value="item?.code"></v-radio>
                <div class="coupon-detail">
                  <p class="mb-1 coupon-detail-title">{{ item?.title }}</p>
                  <p class="mb-0 caption coupon-detail-info">{{ item?.info }}</p> 
                </div>
              </div>
            </div>
          </v-radio-group>
        </v-form>
        <v-card-actions class="d-flex coupon-form-actions">
          <v-btn color="#454545" @click="$emit('closeCouponToggle')">
            取消
          </v-btn>
          <v-btn color="#454545" @click="switchCouponToggle" :disabled="!activeDiscount">
            使用
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getCoupons, redeemCoupon } from '@/api/panel/coupons';
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    discountInput: '',
    coupon: 'discount',
    isEmptyDiscount: false,
    isExchange: false,
    isValidDiscount: false,
    discountItems: [],
    discountDetail: {
      title: '',
      content: '',
      amount: 0,
      code: ''
    },
    activeDiscount: null
  }),
  computed: {},
  watch: {
    activeDiscount(_new, _old) {
      const discountDetail = this.discountItems.find(e => e.code === _new);
      this.discountDetail = discountDetail ? discountDetail : {
        title: '',
        content: '',
        amount: 0,
        code: ''
      }
    }
  },
  methods: {
    switchCouponToggle() {
      this.$emit('switchCouponToggle', {
        ...this.discountDetail
      });
    },
    onCodeInput(evt) {
      if (evt.keyCode === 13) {
        evt.preventDefault();
        this.redeemCoupon();
      }
    },
    async fetchCoupons() {
      const lang = localStorage.getItem('language')
        ? localStorage.getItem('language').toLowerCase()
        : 'tw';

      const couponItems = await getCoupons({
        lang,
      });

      this.discountItems = couponItems;
    },
    async redeemCoupon() {
      const code = this.discountInput.trim();
      if (!code) {
        this.isEmptyDiscount = true;
        return;
      }
      const lang = localStorage.getItem('language')
        ? localStorage.getItem('language').toLowerCase()
        : 'tw';

      const { amount, title, info, code: _code, error } = await redeemCoupon({
        lang,
        code
      });
      if (error) {
        console.log(error);
        this.$toast.error(`${error?.message} \n${error?.error}`  || '無法使用優惠券');
        return;
      }
      const discountDetail = {
        title,
        info,
        amount,
        code
      };
      this.discountItems.push(discountDetail);
      this.$toast('優惠券兌換成功');
      this.discountInput = '';
    }
  },
  mounted() {
    this.fetchCoupons();
  }
};
</script>
<style lang="scss" scoped>
.no-coupon-hint {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  span {
    color: #A6A6A6;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.56px;
  }
}

.coupons-wrapper {
  max-height: 200px;
  overflow-y: auto;
}
.coupon-form {
  padding-top: 0 !important;
  margin: 0;
}

.close-btn {
  width: 30px;
  height: 30px;
  color: $neutral200;
  background-color: #434343;
  border-radius: 50%;
}

.v-input--selection-controls {
  margin-top: 0;
  padding-top: 0;
}
::v-deep {
  .v-text-field__details {
    display: none;
  }

  .coupon-list {
    .theme--dark.v-icon {
      color: $neutral300;
      font-size: 18px;
    }

    .v-label {
      font-size: 14px;
    }
  }
  .error-input {
    .v-input__control {
      border: 1px solid #ff5084;
    }
  }
  .discount-input {
    border-radius: 4px;
    padding: 0 16px;

    .v-input__slot {
      margin-bottom: 0;
      padding: 0;

      &::before,
      &::after {
        content: initial;
      }
    }
  }
}

.coupon-item {
  height: 40px;
  margin-bottom: 24px;
}

.coupon-form-actions {
  justify-content: flex-end;
  padding: 0 !important;
}

.exchange-btn {
  border-color: $neutral200;
}

.coupon-detail-title {
  color: $neutral100;
  font-size: 14px;
}

.coupon-detail-info {
  color: $neutral200;
}
</style>